import React from 'react';

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-grid-bg"></div>
      <div className="hero-glow"></div>
      <div className="hero-inner">
        <div>
          <p className="hero-eyebrow">The Complete M&A Operating System</p>
          <h1 className="hero-headline">
            Exit Smarter.<br />Exit <em>Stronger.</em><br />Exit on Your Terms.
          </h1>
          <p className="hero-tagline">Value Beyond Numbers™</p>
          <p className="hero-sub">
            For IT services founders who refuse to leave value on the table. Five integrated modules. One continuous journey — from preparation to the closing table.
          </p>
          <div className="hero-promise">
            <span className="promise-item">Get Ready</span>
            <span className="promise-item">Uplift Valuation 20–40%</span>
            <span className="promise-item">Find the Right Buyer</span>
            <span className="promise-item">Close</span>
          </div>
          <div className="hero-actions">
            <a href="#enroll" className="btn-primary">Enroll in the Masterclass</a>
            <a href="#modules" className="btn-outline">Explore the Platform</a>
          </div>
        </div>
        <div className="hero-card">
          <p className="hc-label">Your Guide &amp; Advisor</p>
          <p className="hc-name">Sunil Nikhar</p>
          <p className="hc-title">Founder, ValueARC · M&A Advisor · Exit Strategist</p>
          <ul className="cred-list">
            <li>IIT Mumbai · IIM Ahmedabad</li>
            <li>2 Successful Exits — chinadotcom (NASDAQ) &amp; Polaris Financial Technology</li>
            <li>Ernst &amp; Young Entrepreneur of the Year 2002</li>
            <li>12+ M&amp;A Transactions as Buyer, Seller &amp; Advisor</li>
            <li>India Head, Vertical Relevance — Premier AWS Partner</li>
          </ul>
          <div className="launch-dates">
            <div className="launch-item">
              <span className="lbadge green">Live Now</span>
              <div>
                <div className="ldate">16 April 2025</div>
                <div className="ldesc">M&A Masterclass — Module 1</div>
              </div>
            </div>
            <div className="launch-item">
              <span className="lbadge navy">Coming Soon</span>
              <div>
                <div className="ldate">18 June 2026</div>
                <div className="ldesc">Modules 2 &amp; 3 — Dashboard + iVDR</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
